import { Link as RouterLink } from 'react-router-dom';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import logo from '../../assets/logo.png';

function Footer({ companyInfo, navLinks, footerRanges }) {
  return (
    <Box component="footer" sx={{ bgcolor: '#1a0533', color: '#ffffff', mt: 6 }}>
      <Box sx={{ px: { xs: 3, md: 4 }, py: 5 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: '1.3fr 1fr 1fr 1fr' },
            gap: 4,
          }}
        >
          <Box>
            <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: 2 }}>
              <Box
                component="img"
                src={logo}
                alt={`${companyInfo.name} logo`}
                sx={{
                  width: 52,
                  height: 42,
                  objectFit: 'contain',
                  borderRadius: 1.5,
                  bgcolor: '#ffffff',
                  border: '1px solid rgba(201,168,76,0.26)',
                }}
              />
              <Box>
                <Typography sx={{ fontWeight: 900 }}>{companyInfo.name}</Typography>
                <Typography
                  sx={{
                    color: '#c9a84c',
                    fontSize: '0.78rem',
                    textTransform: 'uppercase',
                    letterSpacing: 1.4,
                  }}
                >
                  {companyInfo.tagline}
                </Typography>
              </Box>
            </Stack>
            <Typography sx={{ color: 'rgba(255,255,255,0.72)', maxWidth: 320, lineHeight: 1.8 }}>
              {companyInfo.shortDescription}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              <IconButton
                component="a"
                href={companyInfo.socialLinks.linkedin}
                target="_blank"
                rel="noreferrer"
                sx={{ color: '#c9a84c' }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                component="a"
                href={`mailto:${companyInfo.socialLinks.email}`}
                sx={{ color: '#c9a84c' }}
              >
                <EmailRoundedIcon />
              </IconButton>
            </Stack>
          </Box>
          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              {navLinks.map((link) => (
                <Typography
                  key={link.path}
                  component={RouterLink}
                  to={link.path}
                  sx={{ color: 'rgba(255,255,255,0.72)' }}
                >
                  {link.label}
                </Typography>
              ))}
            </Stack>
          </Box>
          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Product Ranges
            </Typography>
            <Stack spacing={1}>
              {footerRanges.map((range) => (
                <Typography key={range} sx={{ color: 'rgba(255,255,255,0.72)' }}>
                  {range}
                </Typography>
              ))}
            </Stack>
          </Box>
          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Contact Details
            </Typography>
            <Stack spacing={1}>
              <Typography sx={{ color: 'rgba(255,255,255,0.72)' }}>{companyInfo.address}</Typography>
              <Typography sx={{ color: '#c9a84c', fontSize: '1.05rem', fontWeight: 700 }}>{companyInfo.phone}</Typography>
              <Typography sx={{ color: '#c9a84c', fontSize: '1.05rem', fontWeight: 700 }}>{companyInfo.email}</Typography>
            </Stack>
          </Box>
        </Box>
        <Divider sx={{ my: 3, borderColor: 'rgba(201,168,76,0.28)' }} />
        <Typography sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.62)' }}>
          Copyright © {new Date().getFullYear()} {companyInfo.name}. {companyInfo.footerCopyright}
        </Typography>
        <Typography sx={{ mt: 1, textAlign: 'center', color: 'rgba(255,255,255,0.72)', fontSize: '0.82rem' }}>
          Designed & Developed by Yashwant Gehlot
        </Typography>
        <Typography sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.72)', fontSize: '0.82rem' }}>
          Email:{' '}
          <Box
            component="a"
            href="mailto:yashgehlot17@gmail.com"
            sx={{ color: '#c9a84c', textDecoration: 'none' }}
          >
            yashgehlot17@gmail.com
          </Box>{' '}
          Mobile no{' '}
          <Box
            component="a"
            href="tel:9589900261"
            sx={{ color: '#c9a84c', textDecoration: 'none' }}
          >
            9589900261
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
